import { AxiosResponse } from 'axios';
import { DateTime } from 'luxon';
import { ConsumedEvent } from 'shell/models/consumed-event';
import { HttpResponseList } from 'shell/models/http-response';
import { PublishedConsumedEventClient } from 'system/components/published-events/form-published-event/types';

export interface ConsumedEventsResponse {
  pageInfo:
    | {
        totalCount: number;
        page: number;
        pageSize: number;
      }
    | undefined;
  consumedEvents: Array<PublishedConsumedEventClient>;
}

export const transformConsumedEvents = (
  response: AxiosResponse<HttpResponseList<ConsumedEvent>>
): ConsumedEventsResponse => {
  const data = response.data.payload?.list || [];
  const pageInfo = response.data.payload?.pageInfo;

  if (pageInfo) {
    pageInfo.page = pageInfo.page / pageInfo.pageSize;
  }

  return {
    pageInfo,
    consumedEvents: data.map((consumedEvent: ConsumedEvent) => ({
      id: consumedEvent?.id,
      dataTimeConsummation:
        DateTime.fromISO(consumedEvent?.fineElaborazione).toFormat('dd/MM/yyyy HH:mm:ss') || '',
      state: consumedEvent?.statoElaborazione,
      subscriber: consumedEvent?.codiceSottoscrittore.toString(),
      typeDestination: consumedEvent?.codiceTipoDestinazione.toString(),
      progressive: consumedEvent?.progressivo,
      descriptionTypeDestination: consumedEvent?.descrizioneTipoDestinazione,
      descriptionSubscriber: consumedEvent?.descrizioneSottoscrittore,
      hidden: {
        delete: true,
        edit: true,
      },
    })),
  };
};
